<template>
	<div>
		<ValidationProvider
			name="address_id"
			rules="required"
			v-slot="{ errors, valid }"
		>
			<v-card flat>
				<v-card-title primary-title :class="{ 'red--text': !valid }">
					{{ $t("title.address") }}
					<v-icon right color="red" v-if="!valid">mdi-alert</v-icon>
					<v-spacer></v-spacer>
					<v-btn text @click="addAddress()">{{
						$t("label.add_new")
					}}</v-btn>
				</v-card-title>
				<v-card-text>
					<v-item-group v-model="item.address_id" mandatory>
						<v-row>
							<v-col
								v-for="(address, i) in addresses"
								:key="i"
								cols="12"
								md="4"
							>
								<v-item
									v-slot="{ active, toggle }"
									:value="address.id"
								>
									<v-card
										flat
										@click="toggle"
										outlined
										raised
										tile
										:color="
											active ? 'grey lighten-4' : null
										"
									>
										<v-card-title primary-title>
											<v-icon
												left
												v-if="address.name == 'home'"
												>mdi-home</v-icon
											>
											<v-icon left v-else
												>mdi-map-marker</v-icon
											>
											{{ address.name }}
											<v-spacer></v-spacer>

											<v-btn icon>
												<v-icon>
													{{
														active
															? "mdi-radiobox-marked"
															: "mdi-radiobox-blank"
													}}
												</v-icon>
											</v-btn>
											<v-btn
												text
												icon
												small
												color="primary"
												@click="editAddress(address)"
											>
												<v-icon>mdi-pencil</v-icon>
											</v-btn>
											<v-btn
												text
												icon
												small
												color="red"
												@click="deleteAddress(address)"
											>
												<v-icon>mdi-delete</v-icon>
											</v-btn>
										</v-card-title>
										<v-card-text>
											{{ address.house_number }},
											{{ address.street }}
											<p>
												<v-icon left small
													>mdi-map-marker</v-icon
												>
												{{ address.address }}
											</p>
											<p>
												<v-icon left small
													>mdi-account</v-icon
												>
												{{ address.contact_person }}
												<br />
												<v-icon left small
													>mdi-cellphone</v-icon
												>
												{{ address.phone_number }}
											</p>
										</v-card-text>
									</v-card>
								</v-item>
							</v-col>
						</v-row>
					</v-item-group>
				</v-card-text>
			</v-card>
		</ValidationProvider>

		<v-dialog :value="$wait.is('opening address form')" persistent>
			<ValidationObserver ref="obs" v-slot="{ invalid }">
				<v-card>
					<v-card-title primary-title>
						{{ $t("title.address_form") }}
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<ShopFormAddress v-model="address"></ShopFormAddress>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn
							text
							@click="$wait.end('opening address form')"
							>{{ $t("Close") }}</v-btn
						>
						<v-btn
							color="primary"
							@click.native="submitAddress()"
							:loading="address.processing"
							:disabled="invalid"
						>
							<v-icon left>mdi-content-save</v-icon>
							{{ $t("Save") }}
						</v-btn>
						<v-spacer></v-spacer>
					</v-card-actions>
				</v-card>
			</ValidationObserver>
		</v-dialog>
	</div>
</template>

<script>
import ShopFormAddress from "./ShopFormAddress.vue";
export default {
	components: {
		ShopFormAddress,
	},

	props: ["value", "addresses"],

	data() {
		return {
			address: this.$inertia.form({
				name: "home",
				house_number: null,
				street: null,
				address: null,
				phone_number: this.$page.props.auth.customer.phone,
				contact_person: this.$page.props.auth.customer.display_name,
				description: null,
				latitude: 11.562454466918203,
				longitude: 104.92219185180667,
			}),
		};
	},

	computed: {
		item: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit("input", value);
			},
		},
	},

	methods: {
		submitAddress() {
			if (this.address.uuid) {
				this.address.put(
					this.$route("shop.addresses.update", {
						address: this.address.uuid,
						response: "json",
					}),
					{
						onSuccess: () => this.$wait.end("opening address form"),
						preserveScroll: true,
						preserveState: true,
					}
				);
			} else {
				this.address.post(
					this.$route("shop.addresses.store", {
						response: "json",
					}),
					{
						onSuccess: () => this.$wait.end("opening address form"),
						preserveScroll: true,
						preserveState: true,
					}
				);
			}
		},

		addAddress() {
			this.address = this.$inertia.form({
				name: "home",
				house_number: null,
				street: null,
				address: null,
				phone_number: this.$page.props.auth.customer.phone,
				contact_person: this.$page.props.auth.customer.display_name,
				description: null,
				latitude: 11.562454466918203,
				longitude: 104.92219185180667,
			});
			this.$wait.start("opening address form");
		},

		editAddress(address) {
			this.address = this.$inertia.form(address);
			this.$wait.start("opening address form");
		},

		deleteAddress(address) {
			if (confirm(this.$t("title.delete_address_confirmation"))) {
				this.address.delete(
					this.$route("shop.addresses.destroy", {
						address: address.uuid,
						response: "json",
					}),
					{
						preserveScroll: true,
						preserveState: true,
					}
				);
			}
		},
	},
};
</script>